'use strict';
/* eslint no-undef: 0 */
'use es6';

// Anything that needs to run before the app code runs lives here.

var _legacyHubspotBenderContext = require('legacy-hubspot-bender-context');

var _legacyHubspotBenderContext2 = _interopRequireDefault(_legacyHubspotBenderContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Fix for hubspot.bender since signup cannot have inline JS due to it's CSP's.
hns('hubspot.bender', _legacyHubspotBenderContext2.default.bender);